/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "step1--sprite",
  "use": "step1--sprite-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"step1--sprite\"><path d=\"M12.969 16.506H4.315a.389.389 0 1 0 0 .778h8.654a.389.389 0 1 0 0-.778Zm0-4.126H4.315a.389.389 0 1 0 0 .778h8.654a.389.389 0 0 0 0-.778Zm-.79-8.843H5.105a1.57 1.57 0 0 0-1.568 1.568v2.358a1.57 1.57 0 0 0 1.568 1.568h7.074a1.57 1.57 0 0 0 1.568-1.568V5.105a1.57 1.57 0 0 0-1.568-1.568Zm.79 3.926a.79.79 0 0 1-.79.79H5.105a.79.79 0 0 1-.79-.79V5.105a.79.79 0 0 1 .79-.79h7.074a.79.79 0 0 1 .79.79v2.358Z\" fill=\"#232323\" /><path d=\"M19.253 7.074h-1.97V2.747A2.75 2.75 0 0 0 14.538 0H2.747A2.75 2.75 0 0 0 0 2.747v16.506A2.75 2.75 0 0 0 2.747 22h16.506A2.75 2.75 0 0 0 22 19.253V9.821a2.75 2.75 0 0 0-2.747-2.747ZM2.747 21.222a1.971 1.971 0 0 1-1.969-1.97V2.747A1.97 1.97 0 0 1 2.748.778h11.79a1.97 1.97 0 0 1 1.968 1.97v16.505c0 .771.32 1.469.833 1.969H2.747Zm18.475-1.969a1.971 1.971 0 0 1-1.97 1.97 1.971 1.971 0 0 1-1.969-1.97v-11.4h1.97a1.97 1.97 0 0 1 1.969 1.968v9.432Z\" fill=\"#232323\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
